import type { BlockVisibility } from '@domain/schemas/block.schema';
import type { ResourceBlock } from '@domain/schemas/contract.schema';

export const getExistingVariationsVisibilityConfig = ({
  variations = [],
  visibility,
}: Pick<ResourceBlock, 'variations' | 'visibility'>): BlockVisibility['variations'] => {
  if (!visibility?.variations) return [];
  const existingVariants = new Set(variations.map(({ id }) => id));
  return visibility.variations?.filter((item) => item && existingVariants.has(item.id));
};
